import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "pencil--contured",
  "use": "pencil--contured-usage",
  "viewBox": "12.188 -0.156 571.007 842.139",
  "content": "<symbol viewBox=\"12.188 -0.156 571.007 842.139\" id=\"pencil--contured\"><path d=\"M32.449 218.362l285.042 479.989a68.218 68.218 0 0 0 25.449 25.451l193.421 114.016a50.96 50.96 0 0 0 7.636 3.563 36.12 36.12 0 0 0 23.414-3.563 32.575 32.575 0 0 0 15.779-28.504l-7.636-224.979a82.489 82.489 0 0 0-10.688-33.596L281.352 70.751C240.59 2.019 151.828-20.656 83.096 20.105 14.364 60.867-8.311 149.63 32.449 218.362zm369.028 466.755l112.998-66.678 5.09 136.412-118.088-69.734zM150.03 268.244l133.867-80.422L491.57 564.484a645.882 645.882 0 0 1-132.341 81.949L150.03 268.244zM75.715 124.197a81.438 81.438 0 0 1 38.175-50.9 86.024 86.024 0 0 1 62.607-8.653 79.405 79.405 0 0 1 50.9 38.175l16.797 27.995-142.012 84.495-18.324-27.995a87.047 87.047 0 0 1-8.143-63.117z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./application/components/dumb/icon/src/pencil--contured.svg
// module id = 174
// module chunks = 0